import { render, staticRenderFns } from "./VasionSchedulersPage.vue?vue&type=template&id=150c9952&scoped=true&"
import script from "./VasionSchedulersPage.vue?vue&type=script&lang=js&"
export * from "./VasionSchedulersPage.vue?vue&type=script&lang=js&"
import style0 from "./VasionSchedulersPage.vue?vue&type=style&index=0&id=150c9952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c9952",
  null
  
)

export default component.exports